import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";
import { GetSelectedDate, GetSelectedDropdownValues, InitializeDateSelector, InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";
import { CreateSeries_ActualDays, CreateSeries_EverDay } from "../../../../shared/scripts/graphing/graphing-functions";
import { Unique } from "../../../../shared/scripts/array-functions";
import { BudgetDataPoint, FinancialForecastEntry, ForecastGraphDataPoint } from "./financials.forecast.entities";
import { HistoricalFinancialSpendEntry, InvoicedGraphDataPoint, EstimatedGraphDataPoint, CumulativeInvoiceEntry } from "./financials.spend.entities";
import { forEach } from "lodash";
import _ from 'lodash';
import { FinancialForecastLineChart } from "./financials.forecast.linechart";
import { FinancialForecastTable } from "./financials.forecast.table";
import { FinancialForecastBarChart } from "./financials.forecast.barchart";

export class ForecastSection implements IFilter {
    dataTable: any;
    currentItems: FinancialForecastEntry[];

    categoryItems: FinancialForecastEntry[] = [];
    currentCategoryItems: FinancialForecastEntry[];


    allHistoricalItems: HistoricalFinancialSpendEntry[] = [];
    currentHistoricalItems: HistoricalFinancialSpendEntry[] = [];
    allCumulativeItems: CumulativeInvoiceEntry[] = [];
    currentCumulativeItems: CumulativeInvoiceEntry[] = [];

    allTEItems: FinancialForecastEntry[] = [];
    allPEItems: FinancialForecastEntry[] = [];

    itemsByMonthPE: FinancialForecastEntry[] = [];
    itemsByMonthTE: FinancialForecastEntry[] = [];

    forecastGraphPointsPE: ForecastGraphDataPoint[] = [];
    forecastGraphPointsTE: ForecastGraphDataPoint[] = [];


    estimatedGraphPoints: EstimatedGraphDataPoint[] = [];
    cumulativeGraphPoints: InvoicedGraphDataPoint[] = [];
    budgetGraphPoints: BudgetDataPoint[] = [];


    forecastPEChart: any;
    forecastTEChart: any;

    currentForecastType: string;

    lineChart: FinancialForecastLineChart = new FinancialForecastLineChart();

    barChart: FinancialForecastBarChart;

    constructor(financialsPE: FinancialForecastEntry[], financialsTE: FinancialForecastEntry[], historicalSpend: HistoricalFinancialSpendEntry[], cumulativeInvoiced: CumulativeInvoiceEntry[]) {
        financialsPE.forEach(financial => financial.initialize());
        financialsTE.forEach(financial => financial.initialize());
        historicalSpend.forEach(financial => financial.initialize());
        cumulativeInvoiced.forEach(financial => financial.initialize());


        this.currentForecastType = "PE";

        this.allHistoricalItems = historicalSpend;
        this.allPEItems = financialsPE;
        this.allTEItems = financialsTE;

        this.currentHistoricalItems = this.allHistoricalItems;
        this.allCumulativeItems = cumulativeInvoiced;
        this.currentCumulativeItems = cumulativeInvoiced;

        this.currentItems = financialsPE;
        this.categoryItems = this.getCategoryItems(financialsPE);
        this.currentCategoryItems = this.categoryItems;
        this.itemsByMonthPE = this.getItemsByMonth(financialsPE);
        this.itemsByMonthTE = this.getItemsByMonth(financialsTE);

        const initialTableItems = this.getItemsByMonth(financialsPE, true);


        //this.initializeDataTable(this.tableId, this.itemsByMonthPE);
        this.dataTable = new FinancialForecastTable(initialTableItems);
        this.barChart = new FinancialForecastBarChart(this.allTEItems, this.allPEItems);

        this.forecastPEChart = this.lineChart.initializeChart('projected-enrollment-forecast-chart', "Cumulative Cost", this.lineChart.createChartSeries());
        this.forecastTEChart = this.lineChart.initializeChart('trending-enrollment-forecast-chart', "Cumulative Cost", this.lineChart.createChartSeries(true));

        this.initializeFilters();
        //this.setupInputWatcher()
        this.triggerFilter();


        $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
            //to setup dropdowns to go downwards

            if (e.currentTarget.id == "forecast-tab") {
                ['#study-forecast-dropdown', '#category-forecast-dropdown'].forEach((id: string) => $(id).selectpicker("refresh"));
            }
        });

        this.initiateZoomButtons();



        $("#forecast-tab").on('click', () => {
            setTimeout(() => {
                this.dataTable.columns.adjust();
            }, 500)
        });

    }

    initializeFilters() {
        let studiesLists: string[] = [];
        this.allPEItems.map(invoice => {
            if (!studiesLists.includes(invoice.Platform) && invoice.Platform != null && invoice.Platform != "") {
                studiesLists.push(invoice.Platform);
            }
        })
        studiesLists.sort();
        let categoriesLists: string[] = [];
        forEach(this.categoryItems, financial => {
            if (!categoriesLists.includes(financial.Category)) categoriesLists.push(financial.Category);
        });


        InitializeFilterDropdown('#study-forecast-dropdown', studiesLists, this);
        InitializeFilterDropdown('#category-forecast-dropdown', categoriesLists, this);
    }

    triggerFilter(): void {

        this.barChart.drillupTable();
        let items = [];

        if (this.currentForecastType == "PE") {
            items = this.allPEItems;
        }
        else if (this.currentForecastType == "TE") {
            items = this.allTEItems;
        }

        // Study
        items = items.filter(item => GetSelectedDropdownValues("#study-forecast-dropdown").includes(item.Platform));

        // Category
        items = items.filter(item => GetSelectedDropdownValues("#category-forecast-dropdown").includes(item.Category));

        this.currentItems = items;

        let peForecasts = this.allPEItems;
        peForecasts = peForecasts.filter(item => GetSelectedDropdownValues("#study-forecast-dropdown").includes(item.Platform));
        peForecasts = peForecasts.filter(item => GetSelectedDropdownValues("#category-forecast-dropdown").includes(item.Category));

        let teForecasts = this.allTEItems;

        teForecasts = teForecasts.filter(item => GetSelectedDropdownValues("#study-forecast-dropdown").includes(item.Platform));
        teForecasts = teForecasts.filter(item => GetSelectedDropdownValues("#category-forecast-dropdown").includes(item.Category));

        this.itemsByMonthPE = this.getItemsByMonth(peForecasts);
        this.itemsByMonthTE = this.getItemsByMonth(teForecasts);

        let tempGraphPointsPE: ForecastGraphDataPoint[] = [];
        forEach(this.itemsByMonthPE, item => {
            
            let temp = new ForecastGraphDataPoint;
            temp.initialize(item);
            tempGraphPointsPE.push(temp);
        });

        this.forecastGraphPointsPE = tempGraphPointsPE;

        let tempGraphPointsTE: ForecastGraphDataPoint[] = [];
        forEach(this.itemsByMonthTE, item => {

            let temp = new ForecastGraphDataPoint;
            temp.initialize(item);
            tempGraphPointsTE.push(temp);
        });

        this.forecastGraphPointsTE = tempGraphPointsTE;


        




        this.currentHistoricalItems = this.allHistoricalItems.filter(item => GetSelectedDropdownValues("#study-forecast-dropdown").includes(item.Platform));
        this.currentHistoricalItems = this.currentHistoricalItems.filter(item => GetSelectedDropdownValues("#category-forecast-dropdown").includes(item.Category));

        this.currentCumulativeItems = this.allCumulativeItems.filter(item => GetSelectedDropdownValues("#study-forecast-dropdown").includes(item.Platform));
        this.currentCumulativeItems = this.currentCumulativeItems.filter(item => GetSelectedDropdownValues("#category-forecast-dropdown").includes(item.Category));


        let maxBudget = Math.max(...this.itemsByMonthPE.map(item => item.cost_budgeted));


        let tempBudgetGraphPoints: BudgetDataPoint[] = [];

        let dates = [];

        forEach(this.itemsByMonthTE, item => {
            let temp = new BudgetDataPoint;
            temp.initialize(maxBudget, item.Projection_Date);
            tempBudgetGraphPoints.push(temp);
            dates.push(item.Projection_Date);
        });

        //get unique date strings from this.currentCumulativeItems
        let uniqueDates = Unique(this.currentCumulativeItems.map(item => item.Date), true);

        forEach(uniqueDates, item => {

            let temp = new BudgetDataPoint;
            temp.initialize(maxBudget, item);

            if (dates.includes(item)) {
                return;
            } 
            tempBudgetGraphPoints.push(temp);
            dates.push(item);

        });
        this.budgetGraphPoints = tempBudgetGraphPoints;



        let historicalSpendByMonth = this.getHistoricalByMonth(this.currentHistoricalItems);
        //let tempInvoicedGraphPoints: InvoicedGraphDataPoint[] = [];
        //forEach(historicalSpendByMonth, item => {
        //    let temp = new InvoicedGraphDataPoint;
        //    temp.initialize(item);
        //    tempInvoicedGraphPoints.push(temp);
        //});
        //this.cumulativeGraphPoints = tempInvoicedGraphPoints

        let cumulativeSpendByMonth = this.getCumulativeByMonth(this.currentCumulativeItems);
        let tempCumulativeGraphPoints: InvoicedGraphDataPoint[] = [];
        forEach(cumulativeSpendByMonth, item => {
            let temp = new InvoicedGraphDataPoint;
            temp.initialize(item);
            tempCumulativeGraphPoints.push(temp);
        });
        this.cumulativeGraphPoints = tempCumulativeGraphPoints


        let tempEstimateGraphPoints: EstimatedGraphDataPoint[] = [];
        forEach(historicalSpendByMonth, item => {
            let temp = new EstimatedGraphDataPoint;
            temp.initialize(item);
            tempEstimateGraphPoints.push(temp);
        });
        this.estimatedGraphPoints = tempEstimateGraphPoints;



        this.barChart.redrawChart(teForecasts, peForecasts);
        this.updateContent()
    }

    updateContent(): void {
        this.dataTable.clear();
        const tableItems = this.getItemsByMonth(this.currentItems, true);


        this.dataTable.rows.add(tableItems).draw();

        this.forecastPEChart.series[0].setData(CreateSeries_ActualDays(this.forecastGraphPointsPE, false));
        this.forecastTEChart.series[0].setData(CreateSeries_ActualDays(this.forecastGraphPointsTE, false));

        this.forecastPEChart.series[1].setData(CreateSeries_ActualDays(this.cumulativeGraphPoints, false));
        this.forecastPEChart.series[2].setData(CreateSeries_ActualDays(this.estimatedGraphPoints, false));
        this.forecastPEChart.series[3].setData(CreateSeries_ActualDays(this.budgetGraphPoints, false));

        this.forecastTEChart.series[1].setData(CreateSeries_ActualDays(this.cumulativeGraphPoints, false));
        this.forecastTEChart.series[2].setData(CreateSeries_ActualDays(this.estimatedGraphPoints, false));
        this.forecastTEChart.series[3].setData(CreateSeries_ActualDays(this.budgetGraphPoints, false));
    }

    resetFilters(): void {
        this.dataTable.columns.adjust();
        $("#study-forecast-dropdown").selectpicker('selectAll');
        $("#category-forecast-dropdown").selectpicker('selectAll');
        this.triggerFilter();
    }

    getCategoryItems(items: FinancialForecastEntry[]): FinancialForecastEntry[] {
        let financials = items;
        let categories = Unique(financials.map(financial => financial.Category), true);
        let localCategoryItems = [];
        let platforms = Unique(financials.map(financial => financial.Platform), true);
        let platformName = "";
        if (platforms.length == 5) platformName = "All Platforms";
        else if (platforms.length > 1) platformName = "Selected Platforms";
        else platformName = platforms[0];
        forEach(categories, category => {
            let temp = new FinancialForecastEntry;
            temp.Platform = platformName;
            temp.Category = category;
            temp.ID = financials.filter(financial => financial.Category == category)[0].ID.split('.')[0];
            temp.Deliverable = "All Deliverables";
            temp.Unit_Desc = "All Units";
            temp.units_budgeted = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.units_budgeted, 0));
            temp.Latest_Invoice = financials.filter(financial => financial.Category == category).reduce((latest, current) => {
                const latestDate = new Date(latest);
                const currentDate = new Date(current.Latest_Invoice);
                return currentDate > latestDate ? current.Latest_Invoice : latest;
            }, financials[0]?.Latest_Invoice || null);
            temp.Projection_Date = "01/01/2025";
            temp.Billed_to_Date = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.Billed_to_Date, 0));
            temp.cost_budgeted = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.cost_budgeted, 0));
            temp.Projected_Spending = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.Projected_Spending, 0));
            temp.Within_Month_Proj_Spend = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.Within_Month_Proj_Spend, 0));
            temp.Within_Month_Proj_Units = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.Within_Month_Proj_Units, 0));
            temp.Projected_Units = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.Projected_Units, 0));
            temp.Overspending_Units = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.Overspending_Units, 0));
            temp.Overspending_Cost = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.Overspending_Cost, 0));
            temp.source = "All Sources";
            temp.isOverspent = temp.Overspending_Cost > 0;
            temp.CategorySort = 1;
            temp.initialize();

            localCategoryItems.push(temp);
        });
        localCategoryItems.sort((a, b) => parseInt(a.ID) - parseInt(b.ID));
        return localCategoryItems;
    }

    getItemsByMonth(items: FinancialForecastEntry[], isDataTable: boolean = false): FinancialForecastEntry[] {
        let monthItems = items;
        let months = [];
        if (isDataTable) {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth();
            const lastDay = new Date(year, month + 1, 0);
            const mm = String(lastDay.getMonth() + 1).padStart(2, '0');
            const dd = String(lastDay.getDate()).padStart(2, '0');
            const yyyy = lastDay.getFullYear();

            const currentMonthString = mm + '/' + dd + '/' + yyyy;
            months = Unique(monthItems.map(item => item.Projection_Date), true).includes(currentMonthString) ? Unique(monthItems.map(item => item.Projection_Date), true).filter(month => month !== currentMonthString) : months;
        }
        else {
            months = Unique(monthItems.map(item => item.Projection_Date), true);
        }
        let localMonthItems = [];
        let platforms = Unique(monthItems.map(financial => financial.Platform), true);
        let platformName = "";
        if (platforms.length == 5) platformName = "All Platforms";
        else if (platforms.length > 1) platformName = "Selected Platforms";
        else platformName = platforms[0];

        let categories = Unique(monthItems.map(financial => financial.Category), true);
        let categoryName = "";
        if (categories.length == 14) categoryName = "All Categories";
        else if (categories.length > 1 && categories.length < 14) categoryName = "Selected Categories";
        else categoryName = categories[0];

        forEach(months, month => {
            let temp = new FinancialForecastEntry;
            temp.Platform = platformName;
            temp.Category = categoryName;
            temp.ID = monthItems.filter(financial => financial.Projection_Date == month)[0].ID.split('.')[0];
            temp.Deliverable = "All Deliverables";
            temp.Unit_Desc = "All Units";
            temp.units_budgeted = Math.round(monthItems.filter(financial => financial.Projection_Date == month).reduce((acc, item) => acc + item.units_budgeted, 0));
            temp.Latest_Invoice = monthItems.filter(financial => financial.Projection_Date == month).reduce((latest, current) => {
                const latestDate = new Date(latest);
                const currentDate = new Date(current.Latest_Invoice);
                return currentDate > latestDate ? current.Latest_Invoice : latest;
            }, monthItems[0]?.Latest_Invoice || null);
            temp.Projection_Date = month;
            temp.Billed_to_Date = Math.round(monthItems.filter(financial => financial.Projection_Date == month).reduce((acc, item) => acc + item.Billed_to_Date, 0));
            temp.cost_budgeted = Math.round(monthItems.filter(financial => financial.Projection_Date == month).reduce((acc, item) => acc + item.cost_budgeted, 0));
            temp.Projected_Spending = Math.round(monthItems.filter(financial => financial.Projection_Date == month).reduce((acc, item) => acc + item.Projected_Spending, 0));
            temp.Within_Month_Proj_Spend = Math.round(monthItems.filter(financial => financial.Projection_Date == month).reduce((acc, item) => acc + item.Within_Month_Proj_Spend, 0));
            temp.Within_Month_Proj_Units = Math.round(monthItems.filter(financial => financial.Projection_Date == month).reduce((acc, item) => acc + item.Within_Month_Proj_Units, 0));
            temp.Projected_Units = Math.round(monthItems.filter(financial => financial.Projection_Date == month).reduce((acc, item) => acc + item.Projected_Units, 0));
            temp.Overspending_Units = Math.round(monthItems.filter(financial => financial.Projection_Date == month).reduce((acc, item) => acc + item.Overspending_Units, 0));
            temp.Overspending_Cost = Math.round(monthItems.filter(financial => financial.Projection_Date == month).reduce((acc, item) => acc + item.Overspending_Cost, 0));
            temp.source = "All Sources";
            temp.isOverspent = temp.Overspending_Cost > 0;
            temp.CategorySort = 1;
            temp.initialize();

            localMonthItems.push(temp);
        });
        localMonthItems.sort((a, b) => new Date(a.Projection_Date).getTime() - new Date(b.Projection_Date).getTime());
        let forecastBreakpoints = [];
        for (let i = 0; i < localMonthItems.length; i++) {
            if(i+1 < localMonthItems.length) {
                if(localMonthItems[i].Projected_Spending > localMonthItems[i+1].Projected_Spending) {
                    forecastBreakpoints.push(i);
                }  
            }
        }

        const breakPointMap = new Map<number, number > ();


        let monthsByPlatformEntries = [];
        monthsByPlatformEntries = this.getItemsByMonthByPlatform(monthItems, months);
        if (monthsByPlatformEntries.length > 1) {
            for (let i = 0; i < monthsByPlatformEntries.length; i++) {
                forEach(forecastBreakpoints, (breakpoint) => {
                    if (monthsByPlatformEntries[i][breakpoint + 1].Projected_Spending == 0) {
                        if (breakPointMap.has(breakpoint)) {
                            breakPointMap.set(breakpoint, breakPointMap.get(breakpoint) + monthsByPlatformEntries[i][breakpoint].Projected_Spending);
                        }
                        else {
                            breakPointMap.set(breakpoint, monthsByPlatformEntries[i][breakpoint].Projected_Spending);
                        }
                    }


                });
            }
        }

        let toAdd = 0;
        for (let i = 0; i < localMonthItems.length; i++) {
            localMonthItems[i].Projected_Spending += toAdd;
            localMonthItems[i].initialize();
            if (breakPointMap.has(i)) toAdd += breakPointMap.get(i);
        }

        return localMonthItems;

    }

    getHistoricalByMonth(items: HistoricalFinancialSpendEntry[]): HistoricalFinancialSpendEntry[] {
        let monthItems = items;
        let months = Unique(monthItems.map(item => item.Estimation_Date), true);
        let localMonthItems = [];
        let platforms = Unique(monthItems.map(financial => financial.Platform), true);
        let platformName = "";
        if (platforms.length == 5) platformName = "All Platforms";
        else if (platforms.length > 1) platformName = "Selected Platforms";
        else platformName = platforms[0];

        let categories = Unique(monthItems.map(financial => financial.Category), true);
        let categoryName = "";
        if (categories.length == 14) categoryName = "All Categories";
        else if (categories.length > 1) categoryName = "Selected Categories";
        else categoryName = categories[0];

        forEach(months, month => {
            let temp = new HistoricalFinancialSpendEntry;
            temp.Platform = platformName;
            temp.Category = categoryName;
            temp.ID = monthItems.filter(financial => financial.Estimation_Date == month)[0].ID.split('.')[0];
            temp.Deliverable = "All Deliverables";
            temp.Unit_Desc = "All Units";
            temp.units_budgeted = Math.round(monthItems.filter(financial => financial.Estimation_Date == month).reduce((acc, item) => acc + item.units_budgeted, 0));
            temp.Latest_Invoice = month;
            temp.Estimation_Date = month;
            temp.Billed_to_Date = Math.round(monthItems.filter(financial => financial.Estimation_Date == month).reduce((acc, item) => acc + item.Billed_to_Date, 0));
            temp.cost_budgeted = Math.round(monthItems.filter(financial => financial.Estimation_Date == month).reduce((acc, item) => acc + item.cost_budgeted, 0));
            temp.est_spending = Math.round(monthItems.filter(financial => financial.Estimation_Date == month).reduce((acc, item) => acc + item.est_spending, 0));
            temp.est_units = Math.round(monthItems.filter(financial => financial.Estimation_Date == month).reduce((acc, item) => acc + item.est_units, 0));
            temp.Overspending_Units = Math.round(monthItems.filter(financial => financial.Estimation_Date == month).reduce((acc, item) => acc + item.Overspending_Units, 0));
            temp.Overspending_Cost = Math.round(monthItems.filter(financial => financial.Estimation_Date == month).reduce((acc, item) => acc + item.Overspending_Cost, 0));
            temp.source = "All Sources";
            temp.isOverspent = temp.Overspending_Cost > 0;
            temp.CategorySort = 1;
            temp.initialize();

            localMonthItems.push(temp);
        });

        localMonthItems.sort((a, b) => parseInt(a.ID) - parseInt(b.ID));

        return localMonthItems;

    }

    getCumulativeByMonth(items: CumulativeInvoiceEntry[]): CumulativeInvoiceEntry[] {
        let monthItems = items;

        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();
        const lastDay = new Date(year, month + 1, 0);
        const mm = String(lastDay.getMonth() + 1).padStart(2, '0');
        const dd = String(lastDay.getDate()).padStart(2, '0');
        const yyyy = lastDay.getFullYear();

        const currentMonthString = mm + '/' + dd + '/' + yyyy;
        let months = Unique(monthItems.map(item => item.Date), true).includes(currentMonthString) ? Unique(monthItems.map(item => item.Date), true).filter(month => month !== currentMonthString) : Unique(monthItems.map(item => item.Date), true);


        //let months = Unique(monthItems.map(item => item.Date), true);
        let localMonthItems = [];
        let platforms = Unique(monthItems.map(financial => financial.Platform), true);
        let platformName = "";
        if (platforms.length == 5) platformName = "All Platforms";
        else if (platforms.length > 1) platformName = "Selected Platforms";
        else platformName = platforms[0];

        let categories = Unique(monthItems.map(financial => financial.Category), true);
        let categoryName = "";
        if (categories.length == 14) categoryName = "All Categories";
        else if (categories.length > 1) categoryName = "Selected Categories";
        else categoryName = categories[0];

        forEach(months, month => {
            let temp = new CumulativeInvoiceEntry;
            temp.Platform = platformName;
            temp.Category = categoryName;
            temp.ID = monthItems.filter(financial => financial.Date == month)[0].ID.split('.')[0];
            temp.Deliverable = "All Deliverables";
            temp.CumulativeSpend = Math.round(monthItems.filter(financial => financial.Date == month).reduce((acc, item) => acc + item.CumulativeSpend, 0));
            temp.Date = month;
            temp.initialize();

            localMonthItems.push(temp);
        });

        localMonthItems.sort((a, b) => parseInt(a.ID) - parseInt(b.ID));

        return localMonthItems;

    }

    updateForecastTable(option: string) {
        this.currentForecastType = option;
        this.triggerFilter();
    }



    getItemsByMonthByPlatform(items: FinancialForecastEntry[], months: string[]): FinancialForecastEntry[][] {

        let localMonthItemsByPlatform = [];
        let platforms = Unique(items.map(financial => financial.Platform), true);
        

        forEach(platforms, platform => {
            let platformItems = [];
            forEach(months, month => {
                let temp = new FinancialForecastEntry;
                temp.Platform = platform;
                temp.Category = "category";
                temp.ID = "1";
                temp.Deliverable = "All Deliverables";
                temp.Unit_Desc = "All Units";
                temp.units_budgeted = Math.round(items.filter(financial => financial.Projection_Date == month && financial.Platform == platform).reduce((acc, item) => acc + item.units_budgeted, 0));
                temp.Latest_Invoice = items.filter(financial => financial.Projection_Date == month && financial.Platform == platform).reduce((latest, current) => {
                    const latestDate = new Date(latest);
                    const currentDate = new Date(current.Latest_Invoice);
                    return currentDate > latestDate ? current.Latest_Invoice : latest;
                }, items[0]?.Latest_Invoice || null);
                temp.Projection_Date = month;
                temp.Billed_to_Date = Math.round(items.filter(financial => financial.Projection_Date == month && financial.Platform == platform).reduce((acc, item) => acc + item.Billed_to_Date, 0));
                temp.cost_budgeted = Math.round(items.filter(financial => financial.Projection_Date == month && financial.Platform == platform).reduce((acc, item) => acc + item.cost_budgeted, 0));
                temp.Projected_Spending = Math.round(items.filter(financial => financial.Projection_Date == month && financial.Platform == platform).reduce((acc, item) => acc + item.Projected_Spending, 0));
                temp.Within_Month_Proj_Spend = Math.round(items.filter(financial => financial.Projection_Date == month && financial.Platform == platform).reduce((acc, item) => acc + item.Within_Month_Proj_Spend, 0));
                temp.Within_Month_Proj_Units = Math.round(items.filter(financial => financial.Projection_Date == month && financial.Platform == platform).reduce((acc, item) => acc + item.Within_Month_Proj_Units, 0));
                temp.Projected_Units = Math.round(items.filter(financial => financial.Projection_Date == month && financial.Platform == platform).reduce((acc, item) => acc + item.Projected_Units, 0));
                temp.Overspending_Units = Math.round(items.filter(financial => financial.Projection_Date == month && financial.Platform == platform).reduce((acc, item) => acc + item.Overspending_Units, 0));
                temp.Overspending_Cost = Math.round(items.filter(financial => financial.Projection_Date == month && financial.Platform == platform).reduce((acc, item) => acc + item.Overspending_Cost, 0));
                temp.source = "All Sources";
                temp.isOverspent = temp.Overspending_Cost > 0;
                temp.CategorySort = 1;
                temp.initialize();

                platformItems.push(temp);
            });
            platformItems.sort((a, b) => new Date(a.Projection_Date).getTime() - new Date(b.Projection_Date).getTime());

            localMonthItemsByPlatform.push(platformItems);
        });
        return localMonthItemsByPlatform;
    }



    private initiateZoomButtons() {

        $("#projected-enrollment-forecast-chart-resetZoom").hide();


        $("#projected-enrollment-forecast-chart-resetZoom").click(() => {
            this.forecastPEChart.zoomOut();
        });

        $("#trending-enrollment-forecast-chart-resetZoom").hide();


        $("#trending-enrollment-forecast-chart-resetZoom").click(() => {
            this.forecastTEChart.zoomOut();
        });

    }
}